import styled from "styled-components";

export default styled.div`
  width: 21cm;
  height: 29.7cm;
  padding: 17px;
`;